export const GET_NEWS = 'GET_NEWS'
export const SET_NEWS = 'SET_NEWS'
